import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { IAssetCheckOutDto } from '~/models/modules/Asset/Transactions/CheckOut/assetCheckOutDto';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class AssetCheckOutTransactionsService extends ApiServiceBase {
  FromInventory: any = [];
  constructor(injector: Injector, private http: HttpClient) {
      super(injector);
      this.setBase(API_NAMES.assets);
  }
  getCheckOutTransactionHistoryGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }
  createCheckOutTransaction(model:IAssetCheckOutDto){
    return this.client.post<any>(this._url(), model);
  }
  validatePersonLocation(model:IAssetCheckOutDto){
    return this.client.post<any>(this._url(`/validate-location-person`), model);
  }
  validateCheckSettings(model:IAssetCheckOutDto){
    return this.client.post<any>(this._url(`/validate-check-settings`), model);
  }
  validateCheckSettingsConditions(model:IAssetCheckOutDto){
    return this.client.post<any>(this._url(`/validate-conditions`), model);
  }


  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/CheckOutTransaction${v}`);
}
}
